import { render, staticRenderFns } from "./app-header.vue?vue&type=template&id=2435b052&scoped=true&"
import script from "./app-header.vue?vue&type=script&lang=js&"
export * from "./app-header.vue?vue&type=script&lang=js&"
import style0 from "./app-header.vue?vue&type=style&index=0&id=2435b052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2435b052",
  null
  
)

export default component.exports